export enum DynamicFilterKind {
  Checkbox = 'Checkbox',
  DatePicker = 'DatePicker',
  FiltersSection = 'FiltersSection',
  FilterGroup = 'FilterGroup',
  FiltersSet = 'FiltersSet',
  Range = 'Range',
  Select = 'Select',
  Toggle = 'Toggle',
}

export enum DynamicFilterNodeKind {
  filterSet = 'filter',
  filterValue = 'filterValue',
}

export type FilterGroup = {
  activeFiltersCount: number;
  filteredItemsCount: number;
  kind: DynamicFilterKind.FilterGroup;
  label: string;
  nodes: FiltersSection[];
  uid: string;
};

export type FiltersSection = {
  activeFiltersCount: number;
  kind: DynamicFilterKind.FiltersSection;
  nodes: FiltersSet[];
  title: string;
  uid: string;
};

export type FiltersSet = {
  kind: DynamicFilterKind.FiltersSet;
  hasSteps: boolean;
  nodes: DynamicFilterNode[];
  title: string;
  uid: string;
};

type FilterNode = {
  label?: string;
  isDisabled: boolean;
  uid: string;
};

export type DynamicFilterNode =
  | CheckboxFilterNode
  | DatePickerFilterNode
  | RangeFilterNode
  | SelectFilterNode
  | ToggleFilterNode;

export type CheckboxFilterNode = FilterNode & {
  isDisablesSection?: boolean;
  isSearchable?: boolean;
  isHidden?: boolean;
  kind: DynamicFilterKind.Checkbox;
  nodes: CheckboxValueNode[];
};

export type CheckboxValueNode = {
  count: number;
  displayValue: string;
  hasMarginTop?: boolean;
  isFullWidth?: boolean;
  label?: string;
  state: CheckboxFilterState;
  value: string | number;
};

export type DatePickerFilterNode = FilterNode & {
  kind: DynamicFilterKind.DatePicker;
  displayValue: string;
  value: number | null;
};

export enum CheckboxFilterState {
  AllSelected = 'AllSelected',
  Disabled = 'Disabled',
  NoneSelected = 'NoneSelected',
  SomeSelected = 'SomeSelected',
}

export type ToggleFilterNode = FilterNode & {
  kind: DynamicFilterKind.Toggle;
  nodes: ToggleValueNode[];
  selectedIndex: number;
};

export type ToggleValueNode = {
  displayValue: string;
  value: string | number;
};

export type SelectFilterNode = FilterNode & {
  isMultiSelect?: boolean;
  kind: DynamicFilterKind.Select;
  nodes: SelectValueNode[];
  selectedValue: string | number;
  selectedValues?: (string | number)[];
};

export type SelectValueNode = {
  displayValue: string;
  value: string | number;
};

export type RangeFilterNode = FilterNode & {
  kind: DynamicFilterKind.Range;
  maxLabel?: string;
  minLabel?: string;
  nodes: [RangeValueNode, RangeValueNode];
};

export type RangeValueNode = {
  uid: string;
  label: string;
  selectedValue: string | number;
  nodes: SelectValueNode[];
};

// TODO: refactor `value` to always be an array so we can avoid
// the optional values field
export type FilterEvent = {
  path: string[];
  value: string | number;
  values?: (string | number)[];
};

export type OnFilterChange = (e: FilterEvent) => void;
